import * as msgpack from '@mta/msgpack-js-lib';

export default class LoginCredentials {
	constructor(
			/** ?string= */ email = '',
			/** ?string= */ password = ''
	) {
		/** @member {?string} */
		this.email = email;
		/** @member {?string} */
		this.password = password;
	}

	/**
	 * @param {!object} os
	 * @param {!function} genericTypePackers
	 * @param {Number} __uid__
	 * @return {object}
	 */
	pack(os, genericTypePackers, __uid__) {
		return {
			__uid__: __uid__,
			email: os.writeString(this.email),
			password: os.writeString(this.password)
		};
	}

	/**
	 * @param {!object} is
	 * @param {LoginCredentials} value
	 */
	unpack(is, value) {
		if (value.email !== undefined)
			this.email = is.readString(value.email);
		if (value.password !== undefined)
			this.password = is.readString(value.password);
	}
}

msgpack.registerClass('com.arabellesolutions.sdc.b2b.pub.utils.LoginCredentials', LoginCredentials);
